import React, { useEffect, useState } from 'react';
import ReactEcharts from 'echarts-for-react';
import API from '../../../api';

const StatistiqueLivraisonFrs = () => {
    const [etatPercentages, setEtatPercentages] = useState([]);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await API.post('fournisseur/livraison/get_stat');
                const data = response.data.LivraisonFournisseur[0]; // Access the first object in the array
                const etatPercentagesData = [
                    { value: parseFloat(data.etat_percentages[0]['facturé']), name: 'facturé' },
                    { value: parseFloat(data.etat_percentages[0]['non facturé']), name: 'non facturé' },
                ];
                setEtatPercentages(etatPercentagesData);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }

        fetchData();
    }, []);

    const getOptionEtat = () => {
        return {
            toolbox: {
                show: false,
            },
            tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b} : {c} ({d}%)',
            },
            legend: {
                orient: 'vertical',
                left: 'left',
                data: ['facturé', 'non facturé'],
                textStyle: {
                    color: ['#74788d'],
                },
            },
            color: ['#02a499', '#f8b425', '#ec4561', '#38a4f8', '#3c4ccf'],
            series: [
                {
                    name: 'Total sales',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '60%'],
                    data: etatPercentages,
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)',
                        },
                    },
                },
            ],
        };
    };

    return (
        <React.Fragment>
            <p>État Facturation</p>
            <ReactEcharts style={{ height: '350px' }} option={getOptionEtat()} />
        </React.Fragment>
    );
};

export default StatistiqueLivraisonFrs;
